import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from '../styles/Yuki.module.css';

const container = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.08 } },
};
const block = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 120 } },
};

function Yuki() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch('/yuki.json')
      .then((res) => res.json())
      .then(setData)
      .catch(() => setData(null));
  }, []);

  if (!data) {
    return (
      <div className={styles.page}>
        <p className={styles.loading}>Loading Yuki…</p>
      </div>
    );
  }

  return (
    <motion.div
      className={styles.page}
      variants={container}
      initial="hidden"
      animate="visible"
    >
      <motion.header className={styles.hero} variants={block}>
        {data.avatar && (
          <img className={styles.avatar} src={data.avatar} alt={data.name} />
        )}
        <h1 className={styles.name}>{data.name}</h1>
        <p className={styles.tagline}>{data.tagline}</p>
        <p className={styles.intro}>{data.intro}</p>
      </motion.header>

      {data.soul && (
        <motion.section className={styles.section} variants={block}>
          <h2 className={styles.h2}>What I'm like</h2>
          <ul className={styles.soulList}>
            {data.soul.map((line, i) => (
              <li key={i}>{line}</li>
            ))}
          </ul>
        </motion.section>
      )}

      {data.jobs && (
        <motion.section className={styles.section} variants={block}>
          <h2 className={styles.h2}>What I do, on my own</h2>
          <div className={styles.jobs}>
            {data.jobs.map((job, i) => (
              <div className={styles.job} key={i}>
                <div className={styles.jobHead}>
                  <span className={styles.jobName}>{job.name}</span>
                  <span className={styles.jobWhen}>{job.when}</span>
                </div>
                <p className={styles.jobWhat}>{job.what}</p>
              </div>
            ))}
          </div>
        </motion.section>
      )}

      {data.skills && (
        <motion.section className={styles.section} variants={block}>
          <h2 className={styles.h2}>What I can do on request</h2>
          <div className={styles.skills}>
            {data.skills.map((s, i) => (
              <div className={styles.skill} key={i}>
                <span className={styles.skillName}>{s.name}</span>
                <span className={styles.skillWhat}>{s.what}</span>
              </div>
            ))}
          </div>
        </motion.section>
      )}

      {data.recent && data.recent.length > 0 && (
        <motion.section className={styles.section} variants={block}>
          <h2 className={styles.h2}>Lately</h2>
          <ul className={styles.recent}>
            {data.recent.map((r, i) => (
              <li key={i}>
                <span className={styles.recentDate}>{r.date}</span>
                <span className={styles.recentWhat}>{r.what}</span>
              </li>
            ))}
          </ul>
        </motion.section>
      )}

      <motion.footer className={styles.footer} variants={block}>
        Yuki keeps this page current herself. Last updated {data.updated}.
      </motion.footer>
    </motion.div>
  );
}

export default Yuki;
